import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from 'utils/services';

import {
  AcceptInvoiceReqProps,
  AcceptInvoiceResProps,
  DeclineInvoiceReqProps,
  DeclineInvoiceResProps,
  GetPendingInvoicesReqProps,
  GetPendingInvoicesResProps
} from './patientPortalInvoices.types';

export const patientPortalInvoicesApi = createApi({
  baseQuery: baseQueryWithReauth,
  endpoints: (build) => ({
    acceptInvoice: build.mutation<AcceptInvoiceResProps, AcceptInvoiceReqProps>({
      invalidatesTags: ['PendingInvoices'],
      query: (invoiceId) => ({
        method: 'POST',
        url: `/invoices/${invoiceId}/accept`
      })
    }),
    declineInvoice: build.mutation<DeclineInvoiceResProps, DeclineInvoiceReqProps>({
      invalidatesTags: ['PendingInvoices'],
      query: (invoiceId) => ({
        method: 'POST',
        url: `/invoices/${invoiceId}/decline`
      })
    }),
    getPendingInvoices: build.query<GetPendingInvoicesResProps, GetPendingInvoicesReqProps>({
      keepUnusedDataFor: 0,
      providesTags: ['PendingInvoices'],
      query: () => ({
        params: { status: 'pending_acceptance' },
        url: '/invoices'
      })
    })
  }),
  reducerPath: 'patientPortalInvoicesApi',
  tagTypes: ['PendingInvoices']
});

export const { useAcceptInvoiceMutation, useDeclineInvoiceMutation, useGetPendingInvoicesQuery } =
  patientPortalInvoicesApi;
